import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type VariantSliderClasses = 'container' | 'image' | 'interiorImage';

const sliderImageStyles = makeStyles<ISpcTheme, VariantSliderClasses>(
  () => ({
    container: {
      width: '100%',
    },
    image: {
      marginTop: '10px',
      width: '100%',
      height: '100%',
      maxHeight: '320px',
      objectFit: 'contain',
    },
    interiorImage: {
      width: '100%',
      height: '100%',
      maxHeight: 'unset',
      objectFit: 'cover',
    },
  }),
  { name: 'Customise_SliderImage' },
);

export default sliderImageStyles;
